import { c as _c } from "react/compiler-runtime";
import { ReactElement, ReactNode, memo } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import { ProductAsset } from '@spa/components/ProductAssetTypes';
import styles from './asset-link.component.module.scss';
enum AssetContentType {
  PDF,
  IMAGE,
  OTHERS,
}
export interface Props {
  readonly asset: ProductAsset;
  readonly fallbackTitle: string;
  readonly children?: ReactElement | string;
  readonly showIcon?: boolean;
}
function AssetLinkComponent(t0) {
  const $ = _c(8);
  const {
    asset,
    children,
    fallbackTitle,
    showIcon
  } = t0;
  const {
    name,
    source,
    description,
    contentType
  } = asset;
  const derivedTitle = description ?? name;
  let linkContentType = AssetContentType.OTHERS;
  if (contentType === "application/pdf") {
    linkContentType = AssetContentType.PDF;
  } else {
    if (contentType.startsWith("image")) {
      linkContentType = AssetContentType.IMAGE;
    }
  }
  let t1;
  if ($[0] !== linkContentType || $[1] !== showIcon) {
    t1 = linkContentType === AssetContentType.PDF && showIcon ? <ImageComponent src="/assets/icons/picture-as-pdf.svg" alt="PDF icon" width={32} height={32} /> : null;
    $[0] = linkContentType;
    $[1] = showIcon;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const icon = t1;
  const t2 = derivedTitle ?? fallbackTitle;
  const t3 = children ?? name;
  let t4;
  if ($[3] !== icon || $[4] !== source || $[5] !== t2 || $[6] !== t3) {
    t4 = <a className={styles["asset-link"]} href={source} title={t2} target="_blank">{icon}{t3}</a>;
    $[3] = icon;
    $[4] = source;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export default memo(AssetLinkComponent);